export default function (event) {
    var sourceEvent;
    while (sourceEvent = event.sourceEvent)
        event = sourceEvent;
    return event;
}
